function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'coal': 'rgb(52, 59, 69)','ocean': 'rgb(25, 65, 113)','quiet-grey': 'rgb(65, 70, 68)','brick-red': 'rgb(143, 20, 2)','gold-black': 'rgb(255, 215, 0)','red-black': 'rgb(255, 0, 0)','green-black': 'rgb(0, 128, 0)','purple-black': 'rgb(120, 81, 169)','black-green': 'rgb(76, 187, 23)','octane': 'rgb(110, 28, 36)','picante': 'rgb(141, 63, 45)','olive-green': 'rgb(141, 139, 85)',};

    this.images = {'high-vis': 'url("//www.thewarmingstore.com/cdn/shop/files/highvis_120x.png?v=7668721510343234480")','wine': 'url("//www.thewarmingstore.com/cdn/shop/files/wine_120x.png?v=17966983444143862180")','blue-plaid': 'url("//www.thewarmingstore.com/cdn/shop/files/blueplaid_120x.png?v=4484467627842502577")','red-plaid': 'url("//www.thewarmingstore.com/cdn/shop/files/redplaid_120x.png?v=11229749179011127058")','hunter-green': 'url("//www.thewarmingstore.com/cdn/shop/files/hunter-green_120x.png?v=12686361921539270550")','lichen-green': 'url("//www.thewarmingstore.com/cdn/shop/files/lichen-green_120x.png?v=10068923634231521342")','sharkskin-grey': 'url("//www.thewarmingstore.com/cdn/shop/files/sharkskin-grey_120x.png?v=5266156758879155088")','black-olive-green': 'url("//www.thewarmingstore.com/cdn/shop/files/black-olive-green_120x.png?v=14061915742676672593")','black-quiet-shade-grey': 'url("//www.thewarmingstore.com/cdn/shop/files/black-quiet-shade-grey_120x.png?v=3769322510308346847")','mallard-blue': 'url("//www.thewarmingstore.com/cdn/shop/files/mallard_blue_120x.png?v=11634441492622990417")','realtree-edge': 'url("//www.thewarmingstore.com/cdn/shop/files/realtree-edge_120x.png?v=5047521699265399937")','navy-black': 'url("//www.thewarmingstore.com/cdn/shop/files/navy_120x.png?v=17351189687014358029")','purple-black': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-BLT_120x.png?v=2074713801452531742")','orange-navy': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-CHI_120x.png?v=5655212881240428019")','navy-black': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-DEN_120x.png?v=6752895900784995596")','blue-black': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-DET_120x.png?v=11777511685363506755")','gold-black': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-PIT_120x.png?v=15605669476829592428")','navy-green': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-SEA_120x.png?v=1280517086771828911")','maroon-black': 'url("//www.thewarmingstore.com/cdn/shop/files/CB-WAS_120x.png?v=17908933614930147111")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
